import "./index.css";

// Components Imports
import FormatAmount from "../../_utils/FormatAmount/FormatAmount";
import CommonLayout from "../../_utils/CommonLayout";
import TitleSubtitlePair from "../../_utils/TitleSubtitlePair";
import { GlobalConfiguration } from "../../../utils/configurationProvider";
import { linkIdentifier } from "../../../utils/linkIdentifier";

const MISReportCreateConfirm = (props) => {
  const formateDate = (date) => {
    const dates = new Date(date || new Date());
    const day = dates.toLocaleDateString("en-GB", {
      day: "2-digit",
    });
    const month = dates.toLocaleDateString("en-GB", {
      month: "long",
    });
    const year = dates.toLocaleDateString("en-GB", {
      year: "numeric",
    });
    return `${day} ${month}, ${year}`;
  };

  // Field Sets
  const STATUS_FIELDS = new Set([
    "Transaction approval status",
    "Transaction distribution status",
    "Account status",
  ]);

  const DATE_FIELDS = new Set([
    "Account statement entry date",
    "Approved on",
    "Created on",
    "Distribution completion date",
    "Rejected on",
  ]);

  const EMAIL_FIELDS = new Set([
    "Additional recipient",
    "Beneficiary account email ID",
  ]);

  const IFSC_FIELDS = new Set([
    "Beneficiary account IFSC",
    "Owner account IFSC",
  ]);

  const ACCOUNT_NUMBER_FIELDS = new Set([
    "Beneficiary account number",
    "Owner account number",
    "Account number",
  ]);

  const SPECIFIC_PLACEHOLDERS = {
    "Transaction initiator": "Transaction initiator",
    Amount: "Amount",
    "Approved by": "Approved by",
    Username: "Username",
    "Beneficiary account name": "Account name",
    "Account name": "Account name",
    "Beneficiary account bank name": "Bank name",
    "Owner account bank name": "Bank name",
    "Beneficiary account created count": "Number of accounts created",
    "Beneficiary transaction created count": "Number of transactions created",
    "Internal transaction created count": "Number of transactions created",
    "Beneficiary transaction approved count": "Number of transactions approved",
    "Internal transaction approved count": "Number of transactions approved",
    "Opening balance": "Balance",
    "Closing balance": "Balance",
    "Owner account type": "Account type",
    "Beneficiary account PAN": "PAN",
    Category: "Category",
  };

  const getFilterValueSubtitle = (columnName, selectedOption = "") => {
    if (!columnName) return "Detail";

    if (EMAIL_FIELDS.has(columnName)) return "Email ID";
    if (IFSC_FIELDS.has(columnName)) return "IFSC";
    if (ACCOUNT_NUMBER_FIELDS.has(columnName)) return "Account number";
    if (STATUS_FIELDS.has(columnName)) return "Status";
    if (DATE_FIELDS.has(columnName)) return "Date";

    if (SPECIFIC_PLACEHOLDERS[columnName]) {
      return SPECIFIC_PLACEHOLDERS[columnName];
    }

    if (selectedOption === "User") return "Detail";

    return "Detail";
  };

  const renderFilterValue = (columnName, inputValue) => {
    if (columnName === "Amount") {
      return <FormatAmount price={inputValue} />;
    }

    if (columnName === "Labels" && Array.isArray(inputValue)) {
      return inputValue.filter(Boolean).join(", ");
    }

    if (typeof inputValue === "boolean") {
      return inputValue ? "Yes" : "No";
    }

    if (typeof inputValue === "string" || typeof inputValue === "number") {
      return linkIdentifier(inputValue);
    }

    return "";
  };

  const selectedColumns = props?.columnsData.filter((col) => col.selected);

  return (
    <>
      <div
        className={`Mis_report_Main_div px-padding-md Qmd:px-padding-base gap-x-gap-md Qsmd:mx-margin-xs mx-margin-base`}
      >
        <CommonLayout>
          <div className="Mis_report_SelectAcc_div_confirm">
            <div className="flex flex-col gap-y-gap-md relative">
              <p className="font-semibold text-font-md text-text-primary">
                Field
              </p>

              <TitleSubtitlePair
                title={props?.selectedOption}
                subtitle="Field"
                variant="md"
                titleColor="text-primary"
              />
            </div>
          </div>

          {props?.startDate && props?.endDate && (
            <div className="Mis_report_SelectAcc_div_confirm">
              <div className="flex flex-col gap-y-gap-md relative">
                <p className="font-semibold text-font-md text-text-primary">
                  Date Range
                </p>

                <TitleSubtitlePair
                  title={`${formateDate(props?.startDate)} - ${formateDate(
                    props?.endDate,
                  )}`}
                  subtitle="Date range"
                  variant="md"
                  titleColor="text-primary"
                />
              </div>
            </div>
          )}

          <div className="Mis_report_SelectAcc_div_confirm">
            <div className="flex flex-col gap-y-gap-md relative">
              <p className="font-semibold text-font-md text-text-primary">
                Columns
              </p>
              <div>
                {selectedColumns.map((col, index) => (
                  <div key={col.columnId}>
                    <p className="font-normal text-font-md text-text-primary">
                      {col.columnName}
                    </p>

                    {index !==
                      selectedColumns.length -
                        GlobalConfiguration?.lengthCheckOne && (
                      <div className="border-t border-primary-bg my-margin-sm"></div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {props?.selectedValues?.dropdown1 !== "" &&
          props?.selectedValues?.dropdown2 !== "" ? (
            <div className="Mis_report_SelectAcc_div_confirm">
              <div className="flex flex-col gap-y-gap-md relative">
                <p className="font-semibold text-font-md text-text-primary">
                  Sort By{" "}
                  <span className="font-normal text-font-md  text-text-primary">
                    (Optional)
                  </span>
                </p>

                <div className="flex flex-col justify-between gap-y-gap-sm">
                  <TitleSubtitlePair
                    title={props?.selectedValues?.dropdown1}
                    subtitle="Column"
                    variant="md"
                    titleColor="text-primary"
                  />
                  <div className=" border-t-border border-primary-bg"></div>
                  <TitleSubtitlePair
                    title={props?.selectedValues?.dropdown2}
                    subtitle="Sorting"
                    variant="md"
                    titleColor="text-primary"
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="Mis_report_filter_name relative">
              <>
                <div className="w-full flex flex-col gap-gap-md h-fit">
                  <p className="font-semibold text-font-md  text-text-primary">
                    Sort By{" "}
                    <span className="font-normal text-font-md  text-text-primary">
                      (Optional)
                    </span>
                  </p>
                  <TitleSubtitlePair
                    title="Not given"
                    subtitle="Sort by"
                    variant="md"
                    titleColor="text-primary"
                  />
                </div>
              </>
            </div>
          )}

          {props?.filterMapping?.length >
          GlobalConfiguration?.lengthCheckZero ? (
            props?.filterMapping.map((col) => (
              <div
                className="Mis_report_SelectAcc_div_confirm"
                key={col?.columnId}
              >
                <div className="flex flex-col gap-y-gap-md relative">
                  <p className="font-semibold text-font-md text-text-primary tracking- mb-margin-xs">
                    Filter By{" "}
                    <span className="font-normal text-font-md  text-text-primary">
                      (Optional)
                    </span>
                  </p>
                  <div className="flex flex-col justify-between gap-y-gap-sm">
                    <div className="flex flex-col justify-between gap-y-gap-xs">
                      <p className="font-normal text-font-md text-text-primary ">
                        {col?.column_name}
                      </p>
                      <p className="font-normal text-font-xs  text-text-secondary">
                        Column
                      </p>
                    </div>
                    <div className=" border-t-border border-primary-bg"></div>
                    <div className="flex flex-col justify-between gap-y-gap-xs">
                      <p className="font-normal text-font-md text-text-primary ">
                        {col?.criteria_name}
                      </p>
                      <p className="font-normal text-font-xs  text-text-secondary">
                        Criterion
                      </p>
                    </div>
                    {col?.column_name !== "Confidential transaction" &&
                      col?.column_name !== "Credit/Debit" && (
                        <div className=" border-t-border border-primary-bg"></div>
                      )}
                    {col?.column_name !== "Confidential transaction" &&
                      col?.column_name !== "Credit/Debit" && (
                        <div className="flex flex-col justify-between gap-y-gap-xs">
                          <p
                            className={`font-normal text-font-md text-text-primary ${
                              STATUS_FIELDS.has(col?.column_name) ||
                              col?.column_name === "Category"
                                ? "first-letter:uppercase"
                                : ""
                            }`}
                          >
                            {renderFilterValue(
                              col?.column_name,
                              col.input_value,
                            )}
                          </p>

                          <p className="font-normal text-font-xs text-text-secondary">
                            {getFilterValueSubtitle(
                              col?.column_name,
                              props?.selectedOption,
                            )}
                          </p>
                        </div>
                      )}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="Mis_report_filter_name relative">
              <>
                <div className="w-full flex flex-col gap-gap-md h-fit">
                  <p className="font-semibold text-font-md  text-text-primary">
                    Filter By{" "}
                    <span className="font-normal text-font-md  text-text-primary">
                      (Optional)
                    </span>
                  </p>
                  <TitleSubtitlePair
                    title="Not given"
                    subtitle="Filter by"
                    variant="md"
                    titleColor="text-primary"
                  />
                </div>
              </>
            </div>
          )}
        </CommonLayout>
      </div>
    </>
  );
};

export default MISReportCreateConfirm;
